import React__default, { useRef, useContext } from 'react';
import cn from 'classnames';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { childrenToText } from '../../utils.js';
import DropdownContext from './context.js';
import styles from 'ui-components/Dropdown.scss';

var _excluded = ["value", "children", "Component"];
var DropdownItem = function DropdownItem(_ref) {
  var _cn, _cn2;
  var value = _ref.value,
    children = _ref.children,
    Component = _ref.Component,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var element = useRef(null);
  var _useContext = useContext(DropdownContext),
    onSelect = _useContext.onSelect,
    dropdownValue = _useContext.value,
    items = _useContext.items,
    searchString = _useContext.searchString;
  var active = dropdownValue === value;
  var item = items.find(function (x) {
    return x.value === value;
  });
  if (!item) {
    return null;
  }
  if (typeof searchString === "string" && searchString.length > 0 && !item.label.toLowerCase().includes(searchString.toLowerCase())) {
    return null;
  }
  return Component ? /*#__PURE__*/React__default.createElement(Component, _extends({}, props, {
    "data-index": item.index,
    "data-value": value,
    "aria-label": childrenToText(children),
    "aria-selected": active,
    className: cn(styles.item, (_cn = {}, _cn[styles.active] = active, _cn)),
    onClick: function onClick() {
      return onSelect(value);
    }
  }), children) : /*#__PURE__*/React__default.createElement("button", _extends({}, props, {
    ref: element,
    type: "button",
    "data-index": item.index,
    "data-value": value,
    "aria-label": childrenToText(children),
    "aria-selected": active,
    className: cn(styles.item, (_cn2 = {}, _cn2[styles.active] = active, _cn2)),
    onClick: function onClick() {
      return onSelect(value);
    }
  }), children);
};

export default DropdownItem;
//# sourceMappingURL=item.js.map
